<template>
  <div :dir="currentDir" :class="{ rtl: currentDir === 'rtl' }">
    <div
      v-if="showNotificationBanner"
      class="fixed top-0 left-0 right-0 z-50 bg-primary text-white px-6 py-3 flex items-center justify-between shadow-lg"
    >
      <div class="flex items-center gap-3">
        <i class="fas fa-bell text-lg"></i>
        <span class="text-sm font-bold"
          >فعّل الإشعارات عشان تعرف أي حاجة بتحصل فوراً</span
        >
      </div>
      <div class="flex items-center gap-3">
        <button
          @click="requestNotificationPermission"
          class="bg-white text-primary text-xs font-black px-4 py-1.5 rounded-xl hover:bg-slate-100 transition"
        >
          السماح
        </button>
        <button
          @click="showNotificationBanner = false"
          class="text-white/70 hover:text-white text-xs"
        >
          لا شكراً
        </button>
      </div>
    </div>

    <MainLayout v-if="$route.name !== 'Login'">
      <router-view />
    </MainLayout>

    <router-view v-else />
  </div>
</template>

<script setup>
import MainLayout from "@/components/layout/MainLayout.vue";
import { computed, onMounted, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { useNotificationStore } from "@/stores/notification";
import { initAdminPushNotifications } from "@/services/firebase";

const { locale } = useI18n();
const currentDir = computed(() => (locale.value === "ar" ? "rtl" : "ltr"));

watchEffect(() => {
  document.documentElement.dir = currentDir.value;
  document.documentElement.lang = locale.value;
  localStorage.setItem("locale", locale.value);
});

const store = useNotificationStore();
const showNotificationBanner = ref(false);

const bootstrapNotifications = async () => {
  const authToken = localStorage.getItem("admin_token");

  if (!authToken) {
    showNotificationBanner.value = false;
    return;
  }

  try {
    await initAdminPushNotifications();
    await store.init();
  } catch (error) {
    console.error("Notification bootstrap failed:", error);
  } finally {
    showNotificationBanner.value =
      "Notification" in window && Notification.permission === "default";
  }
};

const requestNotificationPermission = async () => {
  try {
    await initAdminPushNotifications();
    await store.init();
  } catch (error) {
    console.error("Notification permission request failed:", error);
  } finally {
    showNotificationBanner.value = false;
  }
};

onMounted(() => {
  bootstrapNotifications();
});
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;900&display=swap");

#app {
  font-family: "Tajawal", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.rtl {
  text-align: right;
}
</style>
